// AppInner.tsx
import { Outlet } from 'react-router-dom';
import { useCheckAccountType } from '@/hooks/useCheckAccountType';
import { Toaster } from '@/components/molecules/Toast';
import Modal from './components/organisms/Modal';
import Toast from './components/V3/Toast';
import DocumentTitleUpdater from './hooks/DocumentTitleUpdater';
import GlobalSpinner from '@/components/organisms/GlobalSpinner';
import { SafeAreaInsets } from './types/global';

interface Props {
  init: boolean;
  safeAreaInsets: SafeAreaInsets;
}

export const AppInner = ({ init, safeAreaInsets }: Props) => {
  useCheckAccountType(); // ✅ Provider 내부에서 안전하게 실행됨

  return (
    <>
      <DocumentTitleUpdater />
      {init ? <Outlet /> : <GlobalSpinner />}
      <Toaster />
      <Modal />
      <Toast topInset={safeAreaInsets.topInset} />
    </>
  );
};
